<!-- 机构设置 -->
<template>
  <div class="basicStyle">
    <el-form
      :model="userInfo"
      :rules="userRules"
      ref="codeInfoForm"
      label-width="140px"
    >
      <el-form-item label="详情描述：" required>
        <el-input
          type="textarea"
          maxlength="500"
          show-word-limit
          style="width: 600px"
          :rows="8"
          placeholder="请详情描述问题或建议"
          v-model="userInfo.content"
          size="mini"
        ></el-input>
      </el-form-item>
      <el-form-item label="图片：">
        <el-upload
          action="#"
          class="avatar-uploader"
          accept="gif,bmp,jpg,jpeg,png"
          :show-file-list="false"
          :multiple="false"
          :auto-upload="false"
          :on-change="handleMapSuccess"
        >
          <img v-if="userInfo.pic_list" :src="userInfo.pic_list" />
          <i v-else class="el-icon-plus" />
        </el-upload>
        <p style="margin-left: 0; color: grey; font-size: 12px">上传jpg或png</p>
      </el-form-item>

      <!-- <el-form-item label="图片：">
        <el-upload
          action="#"
          class="avatar-uploader"
          accept="gif,bmp,jpg,jpeg,png"
          :show-file-list="false"
          :multiple="false"
          :auto-upload="false"
          :on-change="handleAvatarSuccess"
        >
          <img v-if="userInfo.pic_list" :src="userInfo.pic_list" />
          <i v-else class="el-icon-plus" />
        </el-upload>
        <p style="margin-left: 0; color: grey; font-size: 12px">
          上传jpg或png,尺寸88*88像素
        </p>
      </el-form-item> -->
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="editCode()" size="mini">提交</el-button>
      <!-- <el-button @click="resetCodeShow = false" size="mini">取 消</el-button> -->
    </div>
  </div>
</template>

<script>
import commonApi from "@/api/common.js";
import OSS from "ali-oss";
export default {
  name: "userFeedback",
  data() {
    return {
      isCheck: 0, //审核状态 0 未审核 1 审核中 2 审核通过 3 审核拒绝
      userInfo: {},
      userRules: {
        content: [
          { required: true, message: "请输入详情描述", trigger: "blur" },
        ],
        // wechat: [{ required: true, message: "请输入微信号", trigger: "blur" }],
      },
      loading: false,
      // OSS阿里云上传配置信息
      keysArr: {
        AccessKeySecret: "axa8TvZsnh7TPt84P9h3ExcBKNH8H2",
        AccessKeyId: "LTAI5tKbL1F137o429peV8bY",
        UrlHeader: "https://img2.meite.com/",
        Expiration: "",
        SecurityToken: "",
      },
      uploadFilesName: "",
      uploadfile: [],
      checkInfo: {},
      checkStatus: 0,
      editAgainShow: false,
      errShow: false,
      errMsg: "",
      checkId: 0,
      checkStatusAbout: 0,
    };
  },
  created() {},
  watch: {},
  computed: {},
  methods: {
    // 获取年月Fn
    getDate() {
      const date = new Date();
      const year = String(date.getFullYear());
      const month =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      return year + month;
    },
    // 获取随机文件名称
    getFileName(length) {
      const data = [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
      ];
      let nums = "";
      for (let i = 0; i < length; i++) {
        const r = parseInt(Math.random() * 61, 10);
        nums += data[r];
      }
      return nums;
    },
    handleMapSuccess(res, file) {
      // this.coverAdUpstatus = true;
      let limitSize = res.size / 1024 / 1024;
      let type = res.raw.type;
      let upType = res.raw.type.split("/").pop();
      if (
        (limitSize < 2 && type == "image/jpeg") ||
        type == "image/png" ||
        type == "image/jpg"
      ) {
        let name = `questions/${this.getDate()}/${this.getFileName(
          16
        )}.${upType}`;
        //  1111);
        this.FileUpload("ad", name, res.raw);
      } else {
        this.$message({
          type: "error",
          showClose: true,
          message: "只能上传jpeg、jpg或png文件，且大小不超过2M",
        });
        this.coverAdUpstatus = false;
      }
    },
    // 图片上传
    FileUpload(type, name, file) {
      var client = new OSS({
        region: "oss-cn-hangzhou",
        // endpoint: 'oss-cn-hangzhou',
        accessKeyId: this.keysArr.AccessKeyId,
        accessKeySecret: this.keysArr.AccessKeySecret,
        // bucket: 'meitetest',
        bucket: "meitetest",
      });
      client
        .put(name, file)
        .then((res) => {
          this.uploadfile = [
            {
              url: `${this.keysArr.UrlHeader}${res.name}`,
              name: res.name,
            },
          ];

          this.userInfo.pic_list = this.uploadfile[0].url;
          this.$forceUpdate(); //刷新
          console.log("icon", res, this.userInfo.pic_list);
          this.$message({
            message: "上传成功!",
            type: "success",
            showClose: true,
          });
        })
        .catch((err) => {
          //  err);
        });
    },
    async editCode() {
      const res = await commonApi.addComplaint(this.userInfo);
      if (res.code == 200) {
        this.$message({
          message: "提交成功",
          type: "success",
        });
        this.$router.push({ path: "/home" });
      } else {
        this.$message.error(res.message);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-form {
  min-width: 1200px;
}
.basicStyle {
  overflow: auto;
  h1 {
    margin: 10px 0 20px 0;
  }
  /deep/ .el-input,
  .el-textarea {
    width: 300px;
  }
  .dialog-footer {
    // text-align: center;
    margin: 20px 0 20px 200px;
  }
  .notice {
    font-size: 12px;
    color: #409eff;
    margin-left: 200px;
  }
}
.checkCool {
  margin-bottom: 15px;
  font-size: 14px;
  color: #409eff;
  cursor: pointer;
}

h4 {
  margin-bottom: 15px;
  line-height: 30px;
}

/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #409eff;
}
/deep/ .el-input.is-disabled .el-input__inner {
  background-color: #fff;
}
/deep/ .el-textarea.is-disabled .el-textarea__inner {
  background-color: #fff;
}

.popoverClass {
  padding-top: 10px;
  margin-right: 50px;
  p {
    text-align: center;
  }
  /deep/ .el-button {
    border: none;
    padding: 0;
  }
  /deep/ .el-button:focus,
  .el-button:hover {
    background-color: #fff;
  }
  img {
    width: 20px;
    height: 20px;
    // margin: 0 50px 0 10px;
    margin-left: 10px;
  }
}
.extraItem {
  margin-left: 0;
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
}
.extraDiv {
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.el-popover p {
  text-align: left;
  width: 300px;
  padding: 0 10px;
}
/deep/.avatar-uploader .el-upload {
  width: 120px;
  height: 120px;
  line-height: 120px;
}
/deep/.avatar-uploader img {
  width: 120px !important;
  height: 120px;
}
</style>
